import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuthGuard, SuperOpsGuard } from './shared';

export const routes: Routes = [
    {
        path: "",
        loadChildren: () =>
            import("./layout/layout.module").then(
                (m) => m.LayoutModule
            ), canActivate: [AuthGuard, SuperOpsGuard]
    },
    {
        path: "superops-required",
        loadChildren: () =>
            import("./superops-required/superops-required.module").then(
                (m) => m.SuperOpsRequiredModule
            ), canActivate: [AuthGuard]
    },
    {
        path: "sso",
        loadChildren: () =>
            import("./layout/sso/sso.module").then(
                (m) => m.SsoModule
            ),
    },
    {
        path: "**",
        redirectTo: "not-found"
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
    exports: [RouterModule],
})
export class AppRoutingModule {}
